export default __webpack_public_path__ + "media/zurb/img/home/insight_360-d44ed6788997ddd9ac364e571073f612.gif";